/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_Manage_Guides_ButtonInputs */

const en_knp_lookup_manage_guides_button = /** @type {(inputs: Knp_Lookup_Manage_Guides_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage KNP Guides`)
};

const fr_knp_lookup_manage_guides_button = /** @type {(inputs: Knp_Lookup_Manage_Guides_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerer les guides KNP`)
};

const de_knp_lookup_manage_guides_button = /** @type {(inputs: Knp_Lookup_Manage_Guides_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP-Guides verwalten`)
};

const it_knp_lookup_manage_guides_button = /** @type {(inputs: Knp_Lookup_Manage_Guides_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisci le guide KNP`)
};

const ru_knp_lookup_manage_guides_button = /** @type {(inputs: Knp_Lookup_Manage_Guides_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управление гидами КНП`)
};

const es_knp_lookup_manage_guides_button = /** @type {(inputs: Knp_Lookup_Manage_Guides_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrar guías KNP`)
};

const zh_cn2_knp_lookup_manage_guides_button = /** @type {(inputs: Knp_Lookup_Manage_Guides_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理克鲁格国家公园导游`)
};

const ja_knp_lookup_manage_guides_button = /** @type {(inputs: Knp_Lookup_Manage_Guides_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNPガイドの管理`)
};

const hi_knp_lookup_manage_guides_button = /** @type {(inputs: Knp_Lookup_Manage_Guides_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केएनपी गाइड प्रबंधित करें`)
};

const pt_pt2_knp_lookup_manage_guides_button = /** @type {(inputs: Knp_Lookup_Manage_Guides_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerenciar Guias do KNP`)
};

/**
* | output |
* | --- |
* | "Manage KNP Guides" |
*
* @param {Knp_Lookup_Manage_Guides_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_manage_guides_button = /** @type {((inputs?: Knp_Lookup_Manage_Guides_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Manage_Guides_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_lookup_manage_guides_button(inputs)
	if (locale === "de") return de_knp_lookup_manage_guides_button(inputs)
	if (locale === "it") return it_knp_lookup_manage_guides_button(inputs)
	if (locale === "ru") return ru_knp_lookup_manage_guides_button(inputs)
	if (locale === "es") return es_knp_lookup_manage_guides_button(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_lookup_manage_guides_button(inputs)
	if (locale === "ja") return ja_knp_lookup_manage_guides_button(inputs)
	if (locale === "hi") return hi_knp_lookup_manage_guides_button(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_lookup_manage_guides_button(inputs)
	return en_knp_lookup_manage_guides_button(inputs)
});